import ActivityCard from "./ActivityCard";
import { strLang } from "../../functions/strLang";
import CreateActivity from "./CreateActivity";
import { checkDate } from "../../functions/checkDate";
import { isEditor } from "../../functions/isEditor";
import { colorsList } from "../../data/colorsList";

export default function SecondFrame({
  currentAct,
  askEdit,
  secondBox,
  secondFlex,
  askActivity,
  openWarningMsg,
}) {
  return (
    <div
      ref={secondBox}
      style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        width: secondFlex.active
          ? secondFlex.size === "h"
            ? "40%"
            : "100%"
          : "0%",
        height: secondFlex.active
          ? secondFlex.size === "v"
            ? "40%"
            : "100%"
          : "0%",
        overflow: "auto",
        backgroundColor: colorsList.white,
        padding: secondFlex.active ? 10 : 0,
        boxSizing: "border-box",
      }}
    >
      {currentAct.id && (
        <div className="titleDate">{checkDate(currentAct.id)}</div>
      )}
      <CreateActivity
        active={currentAct.id && isEditor}
        onClick={() => askActivity(currentAct.id)}
      />{" "}
      {currentAct.data.length > 0 ? (
        currentAct.data.map((o, index) => (
          <ActivityCard
            key={index}
            data={{ ...o, date: currentAct.id }}
            askEdit={askEdit}
            sBox={"2"}
            openWarningMsg={openWarningMsg}
          />
        ))
      ) : (
        <div style={{ textAlign: "center" }}>
          {currentAct.id ? strLang("noActivities") : ""}
        </div>
      )}
    </div>
  );
}
